import axios from 'axios'
import { MessageBox, Message } from 'element-ui'
import store from '@/store'
import { getToken } from '@/utils/auth'
import { Encrypt, Decrypt } from '@/utils/index.js'
import { SHA256 } from 'crypto-js'

// 动态获取API基础URL
function getBaseURL() {
  // 开发环境使用环境变量
  if (process.env.NODE_ENV === 'development') {
    return process.env.VUE_APP_BASE_API || ''
  }
  
  // 生产环境动态获取当前域名
  const currentOrigin = window.location.origin
  const currentHost = window.location.hostname
  const currentPort = window.location.port
  
  // 如果是本地开发或测试环境
  if (currentHost === 'localhost' || currentHost === '127.0.0.1') {
    return process.env.VUE_APP_BASE_API || ''
  }
  
  // 生产环境：使用当前域名作为API基础地址
  // 注意：API请求路径本身已经包含 /api，所以这里不需要再添加
  const apiPort = process.env.VUE_APP_API_PORT || ''
  
  let baseURL = ''
  
  if (apiPort && apiPort !== currentPort) {
    // 如果指定了不同的API端口
    const protocol = window.location.protocol
    baseURL = `${protocol}//${currentHost}:${apiPort}`
  } else {
    // 使用相同域名和端口
    baseURL = currentOrigin
  }
  
  return baseURL
}

// 创建一个axios实例

const service = axios.create({
  baseURL: getBaseURL(), // url = base url + request url
  // withCredentials: true, // 当跨域请求时发送cookie
  timeout: 60000 // 请求超时
})

// request 拦截器
service.interceptors.request.use(
  config => {
    // 在发送请求之前做些什么
    if (store.getters.token) {
      // 让每个请求携带 token
      // ['X-Token']是一个自定义头键
      // 请根据实际情况修改
      let time = Date.now();
      config.headers['signature'] = SHA256('timestamp' + time + process.env.VUE_APP_BASE_signature).toString();
      config.headers['timestamp'] = time;
      let obj = { token: Decrypt(getToken()), timestamp: time }
      config.headers['Token'] = Encrypt(JSON.stringify(obj));
    }
    return config
  },
  error => {
    // do something with request error
    console.log(error) // for debug
    return Promise.reject(error)
  }
)
// response interceptor 拦截器
service.interceptors.response.use(
  /**
   * 如果您想获得http信息，例如头信息或状态信息
   * Please return  response => response
  */

  /**
   * 通过自定义代码确定请求状态
   * 这只是个例子
   * 还可以通过HTTP状态代码来判断状态
   */
  response => {
    const res = response.data

    // 如果自定义代码不是200，则判断为错误。
    if (res.status_code !== 200) {
      Message({
        message: res.message || 'Error状态错误',
        type: 'error',
        duration: 5 * 1000
      })

      // 50008:非法令牌;50012:其他客户登录;403:令牌过期;
      if (res.status_code === 403 || res.code === 50012 || res.code === 50014) {
        // to re-login
        store.dispatch('user/resetToken').then(() => {
          location.reload()
        })
      }
      return Promise.reject(new Error(res.message || 'Error'))
    } else {
      return res
    }
  },
  error => {
    console.log('err' + error) // for debug
    Message({
      message: error.message,
      type: 'error',
      duration: 5 * 1000
    })
    return Promise.reject(error)
  }
)
export default service
